/**
 * Publish states for the structure definitions.
 */
export enum StructureDefinitionState {
    DRAFT = 'draft',
    IN_USE = 'in_use',
    OBSOLETE = 'obsolete'
}
